var exports = {
  "kL": "GuildIcon.module__container___ZTlwa1",
  "qJ": "GuildIcon.module__containerNoIcon___ZTlwa1",
  "yC": "GuildIcon.module__initials___ZTlwa1",
};

module.exports = exports;
